import React, { ReactNode, useEffect, useMemo, useState } from 'react'
import useBreakpoint from 'use-breakpoint'
import { useLocation } from '@reach/router'

import { usePrevious } from '../../../../hooks'
import { BREAKPOINTS } from '../../../../constants/global'
import { Paths } from '../../../../constants/structure'

import { isLoggedIn } from '../../../../utils/auth'
import { Nav } from '../../../common/nav'

import { NetworkAlert, Header, Footer } from '../../../common'
import { ClientOnly } from '../../../common/clientOnly'
import * as styles from './layoutLoggedIn.module.scss'

const LayoutLoggedIn = ({ children }: { children?: ReactNode }) => {
   const { pathname } = useLocation()
   const { breakpoint } = useBreakpoint(BREAKPOINTS)
   const previousLocationPath = usePrevious(pathname)
   const [menuOpen, setMenuOpen] = useState<boolean>(false)

   const isMobile = useMemo(() => breakpoint === 'mobile', [breakpoint])

   useEffect(() => {
      if (isMobile) {
         setMenuOpen(false)
      }
   }, [isMobile])

   useEffect(() => {
      if (isMobile && previousLocationPath !== pathname) {
         setMenuOpen(false)
      }
   }, [pathname, previousLocationPath, isMobile])

   if (!isLoggedIn()) return children

   return (
      <ClientOnly>
         <div className={styles.wrapper}>
            <NetworkAlert />
            <div className={styles.sidebar}>
               <Header
                  isExpanded={menuOpen}
                  logoLinkHref={Paths.DASHBOARD}
                  onOpenNav={() => setMenuOpen(!menuOpen)}
               />

               {(menuOpen || !isMobile) && (
                  <div className={styles.navContainer}>
                     <Nav />
                  </div>
               )}

               <div className={styles.footer}>
                  <Footer whiteText={isLoggedIn()} />
               </div>
            </div>

            <div className={styles.content}>{children}</div>
         </div>
      </ClientOnly>
   )
}

export default LayoutLoggedIn
